import NotificationSystem from './NotificationSystem';
import './NotificationSystem.scss';

export default NotificationSystem;
